// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"SetPin_pattern-gradient__o4IJp","page":"SetPin_page__w9Tv-","form":"SetPin_form__VQvyL"};